import { ColumnType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import Template1 from "./ReportTemplates/Template1";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { SelectOption } from "../form-components/SelectComponent";
import { TooltipComponent } from "../../components/Component";
import { tasksApis } from "../../api/NewTasks";

const TimeLogReports = () => {
  const [WorkCategoriesList, setWorkCategoriesList] = useState<SelectOption[]>(
    []
  );
  const [userIdFilterData, setUserIdFilterData] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { id: projectId, projectName } = location.state || {};

  // Scroll to top when component mounts or when navigating to this page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const columns: ColumnType<any>[] = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 80,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 100,
      render(text: any, record: any) {
        return (
          <>
            <span
              className="inlineTableCellLink"
              id={`task-${record?.id}`}
              onClick={() => {
                console.log("Task Name Clicked:");

                navigate(`/pms/project/task-detail/${record.id}`, {
                  state: {
                    projectId,
                    projectName,
                    returnPath: location.pathname,
                    returnState: location.state,
                  },
                });
              }}
            >
              {text}
            </span>
            <TooltipComponent
              iconClass="info-circle text-info"
              icon={""}
              id={`task-${record?.taskId}`}
              direction="right"
              text={"Click To View " + text + " Details"}
              containerClassName={"mt-1"}
            />
          </>
        );
      },
    },
    {
      title: "Work Category",
      dataIndex: "workCategoryName",
      key: "workCategoryName",
      width: 120,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "User",
      dataIndex: "userName",
      key: "userName",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Date",
      dataIndex: "logDate",
      key: "logDate",
      width: 100,
      render: (text: string) => text || "N/A"
    },
    {
      title: "Login Hours",
      dataIndex: "loginTime",
      key: "loginTime",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Hrs`)
    },
    {
      title: "Logout Hours",
      dataIndex: "logoutTime",
      key: "logoutTime",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Hrs`)
    },
    {
      title: "Logged Hours",
      dataIndex: "loggedHours",
      key: "loggedHours",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : `${text} Hrs`)
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
  ];

  const fetchStatusDropdown = async () => {
    try {
      const response = await tasksApis.getOwnersFilterData(
        projectId?.toString()
      );
      const { data, status } = response || {};
      if (status) {
        const options = data.map((item: any) => {
          return {
            label: item.userName,
            value: item.userId,
          };
        });
        setUserIdFilterData(options);
      }
    } catch (error) {
      console.error("eroor");
    }
  };

  const fetchWorkCategoriesList = async () => {
    try {
      const response: any = await tasksApis.fetchWorkCatgoriesList();
      const { data, status } = response || {};
      if (status) {
        const formatted = data.map(
          (item: { workCategoryName: any; workCategoryId: any }) => ({
            label: item.workCategoryName,
            value: item.workCategoryId,
          })
        );
        setWorkCategoriesList(formatted);
      }
    } catch (error) {
      console.error("Error fetching work categories:", error);
    }
  };

  useEffect(() => {
    fetchStatusDropdown();
    fetchWorkCategoriesList();
    dispatch(
      updateMenuData([
        {
          text: "Time Log Report",
          link: "/pms/time-log-reports",
        },
      ])
    );
  }, []);
  return (
    <>
      <Template1
        moduleKey={window.location.pathname}
        columns={columns}
        pageTitle="Time Log Report"
        pageDescription=""
        previousPath={{
          link: "/pms/project/reports",
          state: location.state,
        }}
        filters={{
          defaultFilters: {
            dateRange: {
              title: "Logged Date",
            },
          },
          customFilters: [
            {
              type: "multiple_selection",
              name: "workCategoryId",
              label: "Workcategory",
              options: WorkCategoriesList,
            },
            {
              type: "multiple_selection",
              name: "UserId",
              label: "Users",
              options: userIdFilterData,
            },
          ],
        }}
      />
    </>
  );
};

export default TimeLogReports;
